import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { DownArrowIcon } from "components"

const AnimatedArrowIcon = ({ flip }) => (
  <div style={style.iconStyle(flip)}>
    <DownArrowIcon style={style.svg} />
  </div>
)

AnimatedArrowIcon.propTypes = {
  flip: PropTypes.bool
}

const style = {
  iconStyle: flip => ({
    display: "inline-block",
    // transition: 'transform 0.25s',
    // add translateZ to fix position fixed glitches in IOS - https://stackoverflow.com/questions/20832531/mobile-safari-positionfixed-z-index-glitch-when-scrolling
    transform: flip ? "translateZ(1px) rotateX(180deg)" : "translateZ(1px) rotateX(0)",
    verticalAlign: flip ? "initial" : "middle"
  }),
  svg: {
    width: "12px",
    height: "12px",
    display: "block",
    fill: "currentColor"
  }
}

export default Radium(AnimatedArrowIcon)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/animated-arrow-icon.jsx